import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <path
      className="cls-1"
      d="M21,182.5l32.7-34.4,43.1-45.5,18.3-5.7c-7.2,0-13.8.9-20.3-.4-9.8-1.9-18.1-7.7-20.4-17.9,14.9-8.9,33.2-5.2,49.5-.3-21.8-21.3-51.3-3.4-81.4-7.4-1.9.1-1.3-.7.4-1.5,36.5-8.6,75.2-32.6,104.7-7.8,4.4,3.5,9.7,7.9,9.7,7.9,8.4,4.1,14.7,8.2,21.6,13.3,6.4,5.8,10.6,12.8,12.7,21.4,10.4,12.8,21.2,24.6,33.2,35.8,9.1,4.1,12.2,14,8,22.9-.6,5-2.5,9.5-7.3,11.2-3.5,5.7-9.6,7.2-15.9,5.6-10.5-2.7-11.4,17.6-3.3,29.7-7.2,0-13.8-2.2-17.2-7.8l-.7,2.2c-.1.3-.4.3-.9.2-6.8-4.1-5.8-8.4-6.7-12.6,0-.3-.4,0-.4,0l-.7,2.4c-.1.4-1.2,1.7-1.4,1.3l-.8-2.3-3-13.2c-1-4.2-7.1-4.7-10.8-5.5-5.1-1.1-11.5-3.9-16.5-1.3-5.8,5.1-10.1,12.1-13.9,19.1-5.9,10.8-12,24-17.2,38.1,19.9.9,46.5.9,64.7-3.9,13.8-3.6,25.8-11.3,37-19.6,13.7-10.2,21.4-24.2,23.5-40,.2-1.2.3-2.5.5-3.7,3.2-10.3,4.6-21.1,5.6-31.8.6-6.7,1.6-13.5.2-20.1-1.4-6.6-5.2-12.8-9.3-18.3,0,0-13.8-33.5-32.2-44-18.3-10.5-71.5-16.5-71.5-16.5-12.7-2.2-46.2,4.7-56.4,7.8-20.4,4.2-33.7,19.8-44.2,36.7-16.8,27.2-23.9,58.8-18.3,89.3,1.1,5.9,2.8,11.4,5.2,16.6Z"
    />
    <path
      className="cls-1"
      d="M170.5,110.3c3.8,1.5,3.6,5.6,6.4,7.3,1.8-3.4.9-6-.5-8.9-1.6-3.1-5.3-4.8-8.9-4.1-5.1,1-8.8,7.2-6.6,11.4l4.2-4.4c1.1-1.1,4.1-1.8,5.4-1.2Z"
    />
    <path
      className="cls-1"
      d="M119.3,93c-4,0-15.3.8-19,.1-5.5-1.1-14.6-4-15.9-9.7,8.3-5,30.3-1,39.4,1.8,0,0,1.8,1.8-4.6,7.8Z"
    />
  </svg>
);
export default SVGComponent;
